import type {
    FirestoreDataConverter,
    QueryDocumentSnapshot,
    SnapshotOptions,
} from 'firebase/firestore'
import type { AnalysisSet, AnalysisSetDocument } from '~/types/analysisSets'
import { generateThrowSummaryMetrics } from './throwStats'

export const analysisSetConverter: FirestoreDataConverter<AnalysisSet, AnalysisSetDocument> = {
    fromFirestore: (
        snapshot: QueryDocumentSnapshot<AnalysisSet, AnalysisSetDocument>,
        options: SnapshotOptions,
    ): AnalysisSet => {
        const data = snapshot.data(options)
        return {
            ...data,
            id: snapshot.id,
            metrics: generateThrowSummaryMetrics(data.avg),
        } // Adjust this mapping as necessary
    },
    toFirestore: (modelObject: AnalysisSet): AnalysisSetDocument => {
        const { id, metrics, ...analysisSet } = modelObject
        return analysisSet
    },
}
